import { Modes } from '@components/ModeSwitch';

export type Mode = 'tonic' | 'partner';

export const modes: Modes<Mode> = [
  { mode: 'tonic', text: 'TONIC Rewards' },
  { mode: 'partner', text: 'Partner Rewards' },
];
